import { Navigate } from '@sorare/routing';

import { ANY_SPORT_SCORES_MATCHES } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const ScoutingCenterPage = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Navigate
      to={{
        pathname: generateSportContextPath(ANY_SPORT_SCORES_MATCHES),
      }}
    />
  );
};

export default ScoutingCenterPage;
